import Http from '@/services/http';
import {
  AssetsRequestByInstallations,
  AssetsResponse,
  ChartQuery,
  TemplateRequest,
  TemplateResponse,
  TemplateListRequest,
  TemplateListResponse,
  TemplateVisualization,
  TemplateModuleVariableRequest,
  TemplateModuleVariableResponse,
} from 'sigma-mappings';
import translate from '@/services/translate';

export const UPLOAD_ALLOWED_FILE_TYPES = ['.json'];

const urls = {
  insertTemplate: '/historico-dados/template',
  getList: '/historico-dados/listagem',
  getAssets: '/historico-dados/ativos',
  template: templateId => `/historico-dados/template/${templateId}`,
  visualization: templateId => `/historico-dados/template/${templateId}/visualizacao`,
  variables: '/historico-dados/modulos/variaveis',
  excel: '/historico-dados/exportar/excel',
  importJson: '/historico-dados/template',
  json: templateId => `/historico-dados/template/${templateId}/exportar/json`,
};

const fields = {
  DataInicial: { name: 'fields.general.initial-date' },
  DataFinal: { name: 'fields.general.final-date' },
  Nome: { name: 'general.name' },
};

/* istanbul ignore next */
const error = {
  errorHandling: {
    responseMessageParams: {
      $MA019: data => data,
      $ME090: (data) => ({ 0: data.parameters[0] }),
      $ME091: (data) => ({ 0: data.parameters[0] }),
      $MA001: ({ field }) => {
        const returnedField = fields[field];
        if (!returnedField) return null;
        return { NomeDoCampo: translate(returnedField.name) };
      },
    },
  },
};

export default {
  /**
   * Obtém uma lista de ativos agrupados por empresa/instalação para configuração do relatório.
   */
  getAssets(params) {
    const http = new Http();
    return http.post(urls.getAssets, new AssetsRequestByInstallations(params))
    .then(({ data }) => data.map(item => new AssetsResponse(item)));
  },
  /**
   * Insere um template de relatório de histórico de dados
   */
  insertTemplate(params) {
    const http = new Http(error);
    const mappedParams = new TemplateRequest(params);
    return http.post(urls.insertTemplate, mappedParams)
    .then(({ data }) => data);
  },
  /**
   * Altera um template de relatório de histórico de dados
   */
  updateTemplate(templateId, params) {
    const http = new Http(error);
    return http.put(urls.template(templateId), new TemplateRequest(params));
  },
  /**
   * Obtém um template de relatório de histórico de dados
   */
  getTemplate(templateId) {
    const http = new Http();
    return http.get(urls.template(templateId))
      .then(({ data }) => new TemplateResponse(data));
  },
  /**
   * Exclui um template de relatório de histórico de dados
   */
  deleteTemplate(templateId) {
    const http = new Http();
    return http.delete(urls.template(templateId));
  },
  /**
   * Obtém uma lista de templates de relatórios de histórico de dados
   */
  getList(params) {
    const http = new Http();
    const mappedParams = new TemplateListRequest(params);
    return http.post(urls.getList, mappedParams)
    .then(response => new TemplateListResponse(response.data));
  },
  /**
   * Obtém um template para visualização
   */
  getVisualization(templateId, chartFilters) {
    const http = new Http(error);
    const chartQuery = new ChartQuery(chartFilters);
    return http.get(urls.visualization(templateId), { params: chartQuery })
    .then(({ data }) => data.map(item => new TemplateVisualization(item)));
  },
  /**
   * Obtém uma lista com as variáveis dos módulos especificados pelos ids
   */
  getModuleVariables(params) {
    const mappedParams = new TemplateModuleVariableRequest(params);
    const http = new Http();
    return http.post(urls.variables, mappedParams)
    .then(({ data }) => new TemplateModuleVariableResponse(data));
  },
  /**
   * Envia solicitação de geração de relatório de histórico de dados em Excel
   */
  exportExcel(templateId) {
    const http = new Http({
      ...error,
      download: true,
    });
    return http.post(urls.excel, { id: templateId });
  },
    /**
   * Importação de template
   */
  importTemplate(template) {
    const http = new Http(error);
    return http.post(urls.importJson, template)
    .then(({ data }) => data);
  },
  /**
   * Envia solicitação de geração de relatório de histórico de dados em JSON
   */
  exportJSON(templateId) {
    const http = new Http({
      ...error,
      download: true,
    });
    return http.get(urls.json(templateId));
  },
};
